export enum FrequencyTypeEnum {
  Evaluation = 1,
  Routine = 2,
  Lab = 3,
  Infusion = 4,
  ChemoDisconnect = 5,
  IVStart = 6
}

export const FrequencyTypeOptions = [
{ id: 1, label: 'Evaluation', baseFrequency: true },
{ id: 2, label: 'Routine', baseFrequency: true },
{ id: 3, label: 'Lab', baseFrequency: false },
{ id: 4, label: 'Infusion', baseFrequency: false },
{ id: 5, label: 'Chemo Disconnect', baseFrequency: false },
{ id: 6, label: 'IV Start', baseFrequency: false }
];
